import Breadcrumbs, { AppBreadcrumbs } from '@/shared/components/shared/Breadcrumbs';
import Button from '@/shared/components/shared/Button';
import Link from '@/shared/components/shared/Link';
import NavigationSections from '@/shared/components/shared/NavigationSections';
import Typografed from '@/shared/components/shared/Typografed';
import { AppNavigation } from '@/shared/lib/types';

export type ServiceHeaderSectionProps = {
    breadcrumbs: AppBreadcrumbs;
    h1: string;
    titleDescription: string;
    navigation: AppNavigation;
    buttonText: string;
    buttonLink: string;
};

type Props = React.HTMLAttributes<HTMLElement> & {
    serviceHeaderSectionProps: ServiceHeaderSectionProps;
};

const ServiceHeaderSection = ({ serviceHeaderSectionProps }: Props) => {
    const { breadcrumbs, h1, titleDescription, navigation, buttonText, buttonLink } = serviceHeaderSectionProps;

    return (
        <div className="service-navigation-wrapper">
            <div className="participation-top js-header-theme-trigger wrapper" data-theme="dark" id="top">
                <Breadcrumbs className="participation-breadcrumbs" breadcrumbs={breadcrumbs} />
                <div className="services-page-title-block">
                    <div className="services-page-title h2">
                        <Typografed>{h1}</Typografed>
                    </div>
                    <div className="services-page-description-block">
                        {titleDescription && (
                            <div className="services-page-description text-s">
                                <Typografed>{titleDescription}</Typografed>
                            </div>
                        )}
                        <Button
                            tag={Link}
                            href={buttonLink}
                            target="_blank"
                            rel="noreferrer nofollow"
                            variant={`outline-dark`}
                            className="btn btn-outline-dark services-page-btn"
                        >
                            <Typografed>{buttonText}</Typografed>
                        </Button>
                    </div>
                </div>
                <NavigationSections navigation={navigation} className="services-page-navigation" />
            </div>
        </div>
    );
};

export default ServiceHeaderSection;
